import { Config, ErrorHandling, HtmlContentEditor, TranslationConfig, getjQuery, Authorization } from "@serenity-is/corelib";
import { gridDefaults } from "@serenity-is/sleekgrid";
import { getLanguageList } from "./Helpers/LanguageList";
import { IdleTimeout } from "./Helpers/IdleTimeout";
import { OutOfServiceUnitListGrid } from "../EquipmentInventory/UnitList/UnitListGrid";
import { InspectionReportHavingIssuesGrid, InspectionReportInProgressGrid } from "../EquipmentInventory/InspectionReport/InspectionReportGrid";
import { AlertsDueGrid } from "../EquipmentInventory/Alerts/AlertsGrid";
import { ClosedRepairGrid, OpenInProgressRepairGrid } from "../EquipmentInventory/UnitReparation/UnitReparationGrid";

Config.rootNamespaces.push('Prolink');
TranslationConfig.getLanguageList = getLanguageList;
HtmlContentEditor.CKEditorBasePath = "~/Serenity.Assets/Scripts/ckeditor/";
gridDefaults.useCssVars = false;

let $ = getjQuery();
if ($?.fn?.colorbox) {
    $.fn.colorbox.settings.maxWidth = "95%";
    $.fn.colorbox.settings.maxHeight = "95%";
}

window.onerror = ErrorHandling.runtimeErrorHandler;
window.addEventListener('unhandledrejection', ErrorHandling.unhandledRejectionHandler);

function onDomReady() {
    // Now the DOM is fully loaded, you can safely access elements
    const outOfServiceUnitListGrid = document.getElementById('OutOfServiceUnitListGrid');
    if (outOfServiceUnitListGrid) {
        new OutOfServiceUnitListGrid($('#OutOfServiceUnitListGrid')).init();
    }

    const inspectionReportHavingIssuesGrid = document.getElementById('InspectionReportHavingIssuesGrid');
    if (inspectionReportHavingIssuesGrid) {
        new InspectionReportHavingIssuesGrid($('#InspectionReportHavingIssuesGrid')).init();
    }

    const alertsDueGrid = document.getElementById('AlertsDueGrid');
    if (alertsDueGrid) {
        new AlertsDueGrid($('#AlertsDueGrid')).init();
    }

    const inspectionReportInProgressGrid = document.getElementById('InspectionReportInProgressGrid');
    if (inspectionReportInProgressGrid) {
        new InspectionReportInProgressGrid($('#InspectionReportInProgressGrid')).init();
    }

    const openInProgressRepairGrid = document.getElementById('OpenInProgressRepairGrid');
    if (openInProgressRepairGrid) {
        new OpenInProgressRepairGrid($('#OpenInProgressRepairGrid')).init();
    }

    const closedRepairGrid = document.getElementById('ClosedRepairGrid');
    if (closedRepairGrid) {
        new ClosedRepairGrid($('#ClosedRepairGrid')).init();
    }
}

document.addEventListener('DOMContentLoaded', onDomReady);

$(() => {
    var meta = $('meta[name=username]');
    if ((meta.length && meta.attr('content')) ||
        (!meta.length && Authorization.isLoggedIn)) {

        new IdleTimeout({
            activityTimeout: 700 * 60,
            warningDuration: 2 * 60
        });
    }
});